class WorkPlanIndicatorSrv {
  constructor () {
    var reloadIndicators = []

    function setVariable (variable) {
      reloadIndicators.pop()
      reloadIndicators.push(variable)
      notifyAll()
    }

    function getVariable () {
      return reloadIndicators
    }

    var notifyAll = function () {
      reloadIndicators.reload()
    }

    return {
      setVariable: setVariable,
      getVariable: getVariable
    }
  }
}

WorkPlanIndicatorSrv.$inject = []

export default angular.module('services.WorkPlanIndicatorSrv', []).service('WorkPlanIndicatorSrv', WorkPlanIndicatorSrv).name



// WEBPACK FOOTER //
// ./src/app/u-faculty/workplan/workplanIndicatorSrv.js